var __webpack_exports__ = {};
/*!************************!*\
  !*** ./src/js/card.js ***!
  \************************/
function radioPopup() {
  var radioInputs = document.querySelectorAll('.product-radio__input');
  radioInputs.forEach(function (value) {
    value.onclick = function (e) {
      var selectedValue = e.target.value;
      document.cookie = "selectedVariant=" + selectedValue;
      value.closest(".product-radio").querySelector('button:not(.link-simple)').click();
    };
  });
}
window.addEventListener('load', radioPopup);
